import { getCurrencySymbol } from "@angular/common";
import {
	Component,
	ElementRef,
	EventEmitter,
	inject,
	Input,
	OnInit,
	Output,
	QueryList,
	TemplateRef,
	ViewChildren
} from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { AuctionStatus, ClickarPath, SessionKey } from "@shared/clickar-constants";
import { ConfirmDialogComponent } from "@shared/dialogs/confirm-dialog/confirm-dialog.component";
import { AuctionDTO, ObservedAuctionDTO, TableData } from "@shared/model/auction.model";
import { LotDTO, LotFullDTO, LotVehicle } from "@shared/model/lotDTO";
import { MqttResponse } from "@shared/model/mqtt.response";
import { ApiService } from "@shared/services/api.service";
import { AuctionService } from "@shared/services/auction/auction.service";
import { MqttService } from "@shared/services/mqtt/mqtt.service";
import { SnackbarService } from "@shared/services/snackbar.service";
import { StorageManagerService } from "@shared/services/storage/storage-manager.service";
import { TemplateService } from "@shared/services/template/template.service";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";
import { WcmService } from "@shared/services/wcm/wcm.service";

@Component({
	selector: "app-live-item",
	templateUrl: "./live-item.component.html",
	styleUrl: "./live-item.component.scss",
	standalone: false
})
export class LiveItemComponent implements OnInit {
	private snackBarService = inject(SnackbarService);
	protected ClickarPath = ClickarPath;
	protected Math = Math;
	@Input() observedAuctionDTO: ObservedAuctionDTO;
	@Input() reconnectEmitter: EventEmitter<void>;
	@Input() timeOffset: number = 0;
	/** Triggers when the Auction has to be removed (since all its lots have been trimmed) */
	@Output() trimAuction = new EventEmitter<void>();
	logoAuctioneer: any;
	auction: AuctionDTO;
	defaultLimit = 30;
	defaultOffset = 0;

	tableDataSingle: TableData = {
		// rowsOnPage: 15,
		orderBy: "",
		sortOrder: "desc"/* ,
		offset: this.defaultOffset,
		limit: this.defaultLimit,
		col: 14 */
	};

	tableDataMulti: TableData = {
		// rowsOnPage: 15,
		orderBy: "",
		sortOrder: "desc"/* ,
		offset: this.defaultOffset,
		limit: this.defaultLimit,
		col: 9 */
	};
	/* rowsOnPageSet = [15, 30, 60, 90]; */
	idAuction: number;
	singleLot: LotVehicle[];
	multipleLot: LotFullDTO[];
	offer: number;
	idDealer: number;
	currentRelaunch = 0;
	showContact = false;

	@ViewChildren("singleLotRow") singleLotRow: QueryList<ElementRef>;
	@ViewChildren("multipleLotRow") multipleLotRow: QueryList<ElementRef>;

	constructor(
		private mqttService: MqttService,
		private router: Router,
		public wcmService: WcmService,
		private dialog: MatDialog,
		private storageService: StorageManagerService,
		private auctionService: AuctionService,
		private templateService: TemplateService,
		protected utils: ClickarUtilsService,
		private apiService: ApiService
	) {
		this.tableDataSingle.orderBy = this.storageService.getSessionItem(SessionKey.LIVE_SINGLE_SORTBY, this.tableDataSingle.orderBy || "");
		this.tableDataSingle.sortOrder = this.storageService.getSessionItem(SessionKey.LIVE_SINGLE_SORT_ORDER, this.tableDataSingle.sortOrder || "asc");
		this.tableDataMulti.orderBy = this.storageService.getSessionItem(SessionKey.LIVE_MULTI_SORTBY, this.tableDataMulti.orderBy || "");
		this.tableDataMulti.sortOrder = this.storageService.getSessionItem(SessionKey.LIVE_MULTI_SORT_ORDER, this.tableDataMulti.sortOrder || "asc");
	}

	protected saveOrderBy(multi: boolean, attr: string | string[]) { // NOTE: string[] just to keep TS quiet
		(multi ? this.tableDataMulti : this.tableDataSingle).orderBy = attr as string; // NOTE: casting just to keep TS quiet
		this.storageService.setSessionItem(SessionKey[multi ? "LIVE_MULTI_SORTBY" : "LIVE_SINGLE_SORTBY"], attr);
	}

	protected saveSortOrder(multi: boolean, order: "asc" | "desc") {
		(multi ? this.tableDataMulti : this.tableDataSingle).sortOrder = order;
		this.storageService.setSessionItem(SessionKey[multi ? "LIVE_MULTI_SORT_ORDER" : "LIVE_SINGLE_SORT_ORDER"], order);
	}

	/** Set of lot numbers for which cars lists are open at the moment */
	private openLotLists = new Set<number>();

	/** Lot which is currently visible on mobile */
	protected openLot: LotVehicle | LotFullDTO;

	protected openCarList = (lot: number) => {
		this.openLotLists.add(lot);
		this.storageService.setSessionItem(
			SessionKey.OPEN_CAR_LOT_ACCORDIONS,
			Array.from(this.openLotLists)
		);
	}

	protected closeCarList = (lot: number) => {
		this.openLotLists.delete(lot);
		// this.mobileOpenDetail = null;
		this.storageService.setSessionItem(
			SessionKey.OPEN_CAR_LOT_ACCORDIONS,
			Array.from(this.openLotLists)
		);
	}
	detailsOpen = false;
	protected openLotDetail(lot: LotVehicle | LotFullDTO) {
		this.openLot = lot;
		this.storageService.setSessionItem(
			SessionKey.OPEN_LIVE_LOT_MOBILE,
			lot.lotDTO.idLot
		);
	}
	protected closeAuction() { this.auction.status = AuctionStatus.CLOSED; }
	protected closeLotDetail() {
		this.openLot = null;
		this.storageService.removeSessionItem(
			SessionKey.OPEN_LIVE_LOT_MOBILE
		);
	}

	/** Returns all possible lot statuses */
	private getExtendedLotStatus(lotDTO: { dateEnd: Date, active: boolean }) { return lotDTO.active && this.utils.isLotExtra(lotDTO, this.auction) ? "EXTRA" : this.utils.getLotStatus(lotDTO); }

	protected anyExtraLots() { return this.singleLot.concat(this.multipleLot).some(l => l.lotDTO.calculatedStatus === "EXTRA"); }
	protected isCarListOpen(lot: number) { return this.openLotLists.has(lot); }

	ngOnInit() {
		/* TODO: in teoria le inizializzazioni dovrebbe farle all'aggiornamento degli input, e poi alla cancellazione dei lotto bisognerebbe solo dirlo al padre. Ora invece vengono cancellati sia qui che sopra */
		this.singleLot = [];
		this.multipleLot = [];

		// if (!environment.mobile) {
		this.showContact = true;
		// }
		let openLotId: number;
		if (
			this.storageService.hasSessionItem(
				SessionKey.OPEN_CAR_LOT_ACCORDIONS
			)
		) {
			this.openLotLists = new Set(
				this.storageService.getSessionItem(
					SessionKey.OPEN_CAR_LOT_ACCORDIONS,
					[]
				)
			);
			if (
				this.storageService.hasSessionItem(
					SessionKey.OPEN_LIVE_LOT_MOBILE
				)
			) {
				openLotId = this.storageService.getSessionItem(
					SessionKey.OPEN_LIVE_LOT_MOBILE,
					null
				);
			}
		}

		this.idDealer = this.storageService.getSessionItem(SessionKey.DEALER_ID, null);

		this.auction = this.observedAuctionDTO.auctionDTO;
		this.idAuction = this.auction.idAuction;
		if (this.auction.flgMultiAuctioneer) {
			this.templateService
				.getLogoByProvenanceUsingGET(this.auction.provenances)
				.subscribe(value => {
					this.logoAuctioneer = value;
				});
		}
		for (const lot of this.observedAuctionDTO.lotFullDTO) {
			if (lot.lotDTO.flgMultiItem) {
				if (this.idDealer == lot.lotDTO.idDealerBestOffer) {
					lot.lotDTO.bestOffer = lot.lotDTO.notHigherReserve ? 2 : 1;
				} else {
					lot.lotDTO.bestOffer = 0;
				}
				lot.reservePrice = this.auction.reservePrice && lot.lotDTO.notHigherReserve;
				lot.lotDTO.actualPrice = lot.lotDTO.acceptedOffers ? lot.lotDTO.currentPrice : lot.lotDTO.startPrice;
				if (!lot.reservePrice) {
					this.getLotBase(lot);
				}
				lot.lotDTO.calculatedStatus = this.getExtendedLotStatus(lot.lotDTO);
				// Checking whether this is a previously opened lot, and in case opening it up
				if (openLotId && !this.openLot && lot.lotDTO.idLot === openLotId) {
					this.openLot = lot;
				}
				this.multipleLot.push(lot);
			}
			// Single item
			else {
				lot.vehiclesDTO[0].idLot = lot.lotDTO.idLot;

				const lotVehicle = new LotVehicle();
				lotVehicle.reservePrice =
					this.auction.reservePrice && lot.lotDTO.notHigherReserve;

				if (!lotVehicle.reservePrice) {
					this.getLotBase(lot);
				}

				lotVehicle.lotDTO = lot.lotDTO;
				lotVehicle.lotDTO.actualPrice = lotVehicle.lotDTO.acceptedOffers ? lotVehicle.lotDTO.currentPrice : lotVehicle.lotDTO.startPrice;
				lotVehicle.vehicle = lot.vehiclesDTO[0];
				if (this.idDealer == lotVehicle.lotDTO.idDealerBestOffer) {
					lotVehicle.lotDTO.bestOffer = lotVehicle.lotDTO
						.notHigherReserve
						? 2
						: 1;
				} else {
					lotVehicle.lotDTO.bestOffer = 0;
				}
				lotVehicle.lotDTO.calculatedStatus = this.getExtendedLotStatus(lotVehicle.lotDTO);
				// Checking whether this is a previously opened lot, and in case opening it up
				if (openLotId && !this.openLot && lotVehicle.lotDTO.idLot === openLotId) {
					this.openLot = lotVehicle;
				}
				this.singleLot.push(lotVehicle);
			}
		};

		this.subscribeToTopics();

		this.reconnectEmitter.subscribe(() => {
			// console.log("Re-subscribe to topic");
			this.subscribeToTopics();
		});
	}

	/* TODO: verificare se torna col BE */
	protected getMinRelaunchPrice(lotDTO: LotDTO) { return Math.max(lotDTO.userMaxOffer, lotDTO.actualPrice) + this.auction.minRelaunch; }

	isLast(element, vehicles): boolean { return element.idVehicle == vehicles[vehicles.length - 1].idVehicle; }

	makeOffer(element: LotVehicle) {
		const offer: number = element.offer;
		if (offer && Number.isInteger(+element.offer)) {
			this.apiService
				.makeOffer(
					this.idAuction,
					element.lotDTO.idLot,
					element.offer,
					false
				)
				.subscribe(value => {
					const old = element.lotDTO.userMaxOffer;
					if (+offer > +element.lotDTO.userMaxOffer) {
						element.lotDTO.userMaxOffer = offer;
					}

					if (value.accepted) {
						if (value.notHigherReserve) {
							element.lotDTO.bestOffer = 2;
						} else {
							element.lotDTO.basePrice = value.basePrice;
							element.reservePrice = false;
						}
					} else {
						const error = { errorCode: value.errorCode };
						if (
							["400014", "400013", "400016"].includes(
								error.errorCode
							)
						) {
							element.lotDTO.userMaxOffer = old;
						}
						this.openErrorPopup(error);
					}
				});
		}

		element.offer = null;
	}
	private openErrorPopup(error): void {
		if (error.errorCode !== "400020") {
			this.snackBarService.show({
				status: "error",
				titlePlaceholder: `error.${error.errorCode}`,
				// messagePlaceholder: "dialog.success.title"
			});
		}
	}

	isClosed(element?: { lotDTO: LotDTO }) {
		if (element) {
			const lot = this.singleLot.filter(
				value => value.lotDTO.idLot === element.lotDTO.idLot
			)[0];
			if (lot) {
				return this.utils.getLotStatus(lot.lotDTO) === AuctionStatus.CLOSED;
				// return lot.lotDTO.active === false; // NOTE: in case it's null, the lot is open (hence isClosed() === false)
				// return !(lot.lotDTO.active ?? true);
			} else {
				const lott = this.multipleLot.find(value => value.lotDTO.idLot == element.lotDTO.idLot);
				return this.utils.getLotStatus(lott.lotDTO) === AuctionStatus.CLOSED;
				// return lott.lotDTO.active === false; // NOTE: in case it's null, the lot is open (hence isClosed() === false)
				// return !(lott.lotDTO.active ?? false);
			}
		}
	}

	private subscribeToTopics() {
		for (const lot of this.singleLot) {
			this.mqttService.subscribe(
				this.mqttService.topic(
					this.auction.idAuction,
					lot.lotDTO.idLot
				),
				msg => {
					const json = MqttResponse.from(JSON.parse(msg.payloadString));
					// console.log("MQTT update", json);
					lot.lotDTO.acceptedOffers = json.acceptedOffers;
					lot.lotDTO.currentPrice = json.price;
					lot.lotDTO.actualPrice = json.acceptedOffers ? lot.lotDTO.currentPrice : lot.lotDTO.startPrice;
					lot.lotDTO.dateLastOffer = json.managedTime;
					lot.lotDTO.dateEnd = json.endTimeForItem;
					lot.lotDTO.active = json.active;
					lot.lotDTO.calculatedStatus = this.getExtendedLotStatus(lot.lotDTO);
					if (+json.userId == this.idDealer) {
						if (json.overMinExpectedOffer) {
							// if (lot.lotDTO.first) {
							this.blink(true, lot.lotDTO.idLot, "green");
							/* } else {
							lot.lotDTO.first = true;
						} */
							this.getLotBase(lot);
							lot.lotDTO.bestOffer = 1;
							lot.reservePrice = false;
						} else {
							lot.lotDTO.bestOffer = 2;
							// if (lot.lotDTO.first) {
							this.blink(true, lot.lotDTO.idLot, "yellow");
							/* } else {
							lot.lotDTO.first = true;
						} */
						}
					} else {
						// if (lot.lotDTO.first) {
						this.blink(true, lot.lotDTO.idLot, "red");
						/* } else {
						lot.lotDTO.first = true;
					} */
						if (json.overMinExpectedOffer) {
							lot.reservePrice = false;
							this.getLotBase(lot);
						}
						lot.lotDTO.bestOffer = 0;
					}
				}
			);
		}
		for (const lot of this.multipleLot) {
			this.mqttService.subscribe(
				this.mqttService.topic(
					this.auction.idAuction,
					lot.lotDTO.idLot
				),
				msg => {
					const json = MqttResponse.from(JSON.parse(msg.payloadString));
					// console.log("MQTT update", json);
					lot.lotDTO.acceptedOffers = json.acceptedOffers;
					lot.lotDTO.currentPrice = json.price;
					lot.lotDTO.actualPrice = json.acceptedOffers ? lot.lotDTO.currentPrice : lot.lotDTO.startPrice;
					lot.lotDTO.dateLastOffer = json.managedTime;
					lot.lotDTO.dateEnd = json.endTimeForItem;
					lot.lotDTO.active = json.active;
					lot.lotDTO.calculatedStatus = this.getExtendedLotStatus(lot.lotDTO);
					if (+json.userId == this.idDealer) {
						if (json.overMinExpectedOffer) {
							// if (lot.lotDTO.first) {
							this.blink(false, lot.lotDTO.idLot, "green");
							/* } else {
							lot.lotDTO.first = true;
						} */
							lot.lotDTO.bestOffer = 1;
							lot.reservePrice = false;
							this.getLotBase(lot);
						} else {
							lot.lotDTO.bestOffer = 2;
							// if (lot.lotDTO.first) {
							this.blink(false, lot.lotDTO.idLot, "yellow");
							/* } else {
							lot.lotDTO.first = true;
						} */
						}
					} else {
						// if (lot.lotDTO.first) {
						this.blink(false, lot.lotDTO.idLot, "red");
						/* } else {
						lot.lotDTO.first = true;
					} */
						if (json.overMinExpectedOffer) {
							lot.reservePrice = false;
							this.getLotBase(lot);
						}
						lot.lotDTO.bestOffer = 0;
					}
				}
			);
		}
	}

	openURL(url: any) {
		window.open(url, "_blank");
	}

	getLotBase(lot: LotVehicle) {
		if (this.utils.isNullOrUndefined(lot.lotDTO.basePrice)) {
			this.auctionService
				.getLotBasePriceUsingGET(lot.lotDTO.idLot)
				.subscribe(value => {
					lot.lotDTO.basePrice = value;
				});
		}
	}
	protected unobserve(idLot: number) {
		this.apiService
			.observeAuctionLotUsingPOST(
				true,
				this.auction.idAuction,
				idLot
			)
			.subscribe((/* value */) => {
				/* TODO: in teoria le inizializzazioni dovrebbe farle all'aggiornamento degli input, e poi alla cancellazione dei lotto bisognerebbe solo dirlo al padre. Ora invece vengono cancellati sia qui che sopra */
				const unobservedLot = this.observedAuctionDTO.lotFullDTO.splice(this.observedAuctionDTO.lotFullDTO.findIndex(l => l.lotDTO.idLot === idLot), 1)[0];
				if (!this.observedAuctionDTO.lotFullDTO.length) {
					this.trimAuction.emit();
				}
				// unobservedLot.observed = false;
				if (unobservedLot.lotDTO.flgMultiItem) {
					// TODO: controllare se funziona
					this.multipleLot.splice(this.multipleLot.findIndex(l => l.lotDTO.idLot === idLot), 1);
					// TODO: cancellare asta se fine lotti
				} else {
					this.singleLot.splice(this.singleLot.findIndex(l => l.lotDTO.idLot === idLot), 1);
				}
			});
	}

	protected getCurrencySymbol = getCurrencySymbol;

	protected getAuctionColorClass(lotDTO: LotDTO) {
		if (lotDTO.acceptedOffers) {
			switch (lotDTO?.bestOffer) {
				case 0:
					return "status-color-not-accepted";
				case 1:
					return "status-color-accepted";
				case 2:
					return "status-color-accepted-reserve";
			}
		}
		return "";
	}

	goToAuctioneerPresentation(idTemplate?: number) {
		this.router.navigate([
			"private/partner",
			{ idTemplate: idTemplate ?? this.auction.idTemplate }
		]);
	}

	private blink(single: boolean, idLot: number, color: string) {
		let elementRows: ElementRef[];
		if (single) {
			elementRows = this.singleLotRow.toArray().filter(item => parseInt(item.nativeElement.getAttribute("idLot")) === idLot);
		} else {
			// console.log(this.multipleLotRow.toArray());
			elementRows = this.multipleLotRow.toArray().filter(item => parseInt(item.nativeElement.getAttribute("idLot")) === idLot);
		}

		for (const el of elementRows) {
			el.nativeElement.classList.add(`${color}Fade`);
			el.nativeElement.addEventListener(
				"animationend",
				() => {
					el.nativeElement.classList.remove(`${color}Fade`);
				}, { once: true }
			);
		}
	}

	closeTemplateModal = () => { };

	openTemplateModal(template: TemplateRef<any>, closeCallback?: (value: any) => void) {
		const dialogRef = this.dialog.open(template);
		if (closeCallback) {
			dialogRef.afterClosed().subscribe(closeCallback);
		}
		this.closeTemplateModal = () => {
			dialogRef.close();
			this.detailsOpen = false;
			this.closeTemplateModal = () => { };
		};
	}

	clickAndBuy(element: any) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.width = "auto";

		this.dialog.open(
			ConfirmDialogComponent,
			dialogConfig
		).afterClosed().subscribe(result => {
			// tslint:disable-next-line:triple-equals
			if (result === "ok") {
				this.apiService
					.makeOffer(this.idAuction, element.lotDTO.idLot, null, true)
					.subscribe((/* value */) => { });
			}
		});
	}
}